<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Solicitud Mtto/Servicio</h5>
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'af-solicitud-mtto-nuevo', params: {} }"
              >
                <i class="fa fa-plus"></i>
                Nueva Solicitud
              </router-link>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refresh</a
              >
            </div>
            <div class="col-sm-6">
              <form
                class="form-inline justify-content-sm-end"
                @submit="filterData"
              >
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Buscar"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterTipo"
                  @click="filterData"
                >
                  <option value="" selected="">---------</option>
                  <option value="S">Servicio</option>
                  <option value="C">Combustible</option>
                  <option value="M">Mantenimiento</option>
                  <option value="R">Reparacion</option>
                </select>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filterEstado"
                  @click="filterData"
                >
                  <option value="">---------</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="9">Anulado</option>
                </select>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th class="">Activo</th>
                <th class="">Encargado</th>
                <th>Fecha</th>
                <th>Tipo</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td>{{ current.numero }}</td>
                <td>{{ current.activo_obj.nombre }}</td>
                <td>{{ current.encargado }}</td>
                <td>{{ current.fecha }}</td>
                <td>{{ current.tipo_str }}</td>
                <td>{{ current.estado_str }}</td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterTipo: null,
      filterEstado: null,
      data: [],
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        tipo: this.filterTipo,
        estado: this.filterEstado,
      });
    },
    filterData(e) {
      e.preventDefault();
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tipo: this.filterTipo,
        estado: this.filterEstado,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterTipo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        tipo: this.filterTipo,
        estado: this.filterEstado,
      });
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      DynamicService.fetch("af", "solicitud-mtto", params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      let self = this;
      self.$router.push({
        name: "af-solicitud-mtto-editar",
        params: { id: current.id },
      });
    },
    showModalEdit() {},
  },
};
</script>
